import React from "react";
import { toast } from "react-toastify";

import {
  PrimaryButton,
  SecondaryButton,
  TextField,
} from "@graffer-inc/console-design-kit";

import { validateUpdateServiceAccount } from "../../../../../../application/domain/service-account/service-account-validation";
import { ServiceAccountCommonUpsertForm } from "../../../service-account-common-upsert-form";

import type { ServiceAccount } from "../../../../../../application/domain/service-account/service-account";

type ServiceAccountUpdateParam = Pick<
  ServiceAccount,
  "description" | "roles" | "groupsRoles"
>;

type Props = {
  serviceAccount: ServiceAccount;
  onClickCancel: () => void;
  onClickUpdate: (param: ServiceAccountUpdateParam) => void;
  disabled: boolean;
};

export const ServiceAccountEditContent: React.FC<Props> = ({
  serviceAccount,
  onClickCancel,
  onClickUpdate,
  disabled,
}) => {
  const [input, setInput] = React.useState<ServiceAccountUpdateParam>({
    description: serviceAccount.description,
    roles: serviceAccount.roles,
    groupsRoles: serviceAccount.groupsRoles,
  });

  const [validationState, setValidationState] = React.useState(
    validateUpdateServiceAccount(input),
  );

  const setInputWithValidation = React.useCallback(
    (input: ServiceAccountUpdateParam) => {
      setInput(input);
      setValidationState(validateUpdateServiceAccount(input));
    },
    [],
  );

  const [shouldDisplayError, setShouldDisplayError] =
    React.useState<boolean>(false);

  const handleClickUpdate = React.useCallback(() => {
    setShouldDisplayError(true);
    if (Object.keys(validationState).length > 0) {
      toast.error("入力内容の不備を修正してください。");
      return;
    }
    onClickUpdate(input);
  }, [onClickUpdate, input, validationState]);

  return (
    <div>
      <nav className="level">
        <div className="level-left"></div>
        <div className="level-right">
          <p className="level-item">
            <SecondaryButton
              text="キャンセル"
              onClick={onClickCancel}
              disabled={disabled}
            />
          </p>
          <p className="level-item">
            <PrimaryButton
              text="更新"
              onClick={handleClickUpdate}
              disabled={disabled}
            />
          </p>
        </div>
      </nav>

      <section>
        <div className="columns">
          <div className="column">
            <TextField
              label="アカウント名"
              value={serviceAccount.accountName}
              onChange={(_e) => {
                return;
              }}
              description="アカウント名は編集できません。"
              placeholder=""
              disabled
              required
            />
          </div>
        </div>

        <ServiceAccountCommonUpsertForm
          input={input}
          onChange={setInputWithValidation}
          tenantId={serviceAccount.tenantId}
          validationState={validationState}
          shouldDisplayError={shouldDisplayError}
        />
      </section>
    </div>
  );
};
